import React, { useEffect, useState, CSSProperties } from 'react'
import Skeleton from '@mui/material/Skeleton';


type SkeletonBackgroundProps = {
  image:string
  style?: CSSProperties
}

const SkeletonBackground: React.FC<SkeletonBackgroundProps> = ({
  image,
  style,
}) => {
  const [isLoaded, setIsLoaded] = useState(false)

  useEffect(() => {
    const img = new Image()
    img.src = image
    img.onload = () => {
      setIsLoaded(true)
    }
  }, [image])

  return(
    <div style={style}>
{isLoaded ? (
      <div
        style={{
          backgroundImage: `url(${image})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          width: '100%',
          height: '100%',
        }}
      />
    ) : (
      <Skeleton
        variant="rectangular"
        animation="wave"
        width="100%"
        height="100%"
        sx={{ backgroundColor: '#474747'}}
      />
    )}
    </div>
  )
}

export default SkeletonBackground
